module.exports = require('./helpers/bundle-url').getBundleURL('aXMci') + "lights.6c6d63d7.jpg" + "?" + Date.now();